import { Autopayment } from 'billing/mediators/billing-autopayment-mediator';

import { BoundAppHeaderActions } from 'reactApp/modules/AppHeaderModule/BoundAppHeaderModule';
import { BoundBillingPermissionsSelectors } from 'reactApp/modules/PermissionsModule/BillingPermissionsModule';

import { billingServiceStateFactory } from './models/billingServiceStateFactory';

define((require, exports, module) => {
    'use strict';

    const CreditCardManager = require('./mediators/CreditCardManager')
        .CreditCardManager;
    const Service = require('system/Service');
    const router = require('system/router');

    const BillingService = Service.extend({
        name: 'billing',

        serviceAvailabilityFeatureName: 'BILLING_SERVICE',

        constructor: function BillingService() {
            BillingService.parent.call(this, {
                serviceState: billingServiceStateFactory.createForOwnProject(),
            });

            CreditCardManager.getInstance().on(
                'change load',
                this._toggleCreditCardButton.bind(this),
            );
        },

        _onSetModelInstance(model) {
            Autopayment.setBalanceModel(model);
        },

        _onLoadFinish() {
            return this._loadCreditCard();
        },

        _loadCreditCard() {
            return CreditCardManager.getInstance()
                .getCard()
                .then(() => {
                    this._toggleCreditCardButton();
                })

                .catch(() => {
                    this._toggleCreditCardButton();
                });
        },

        _toggleCreditCardButton() {
            if (
                !this.getModel() ||
                !this.isActivated() ||
                CreditCardManager.getInstance().hasError() ||
                !CreditCardManager.getInstance().hasInfo()
            ) {
                return;
            }

            const card = CreditCardManager.getInstance().card;
            const permissions = BoundBillingPermissionsSelectors.getPermissions();

            if (
                !card &&
                !localStorage.getItem(
                    this.getModel().id + '|has-credit-card',
                ) &&
                permissions.bindCard
            ) {
                if (!this._cardButtonId) {
                    this._cardButtonId = BoundAppHeaderActions.addItem({
                        id: 'creditCard',
                        text: 'Привязать карту',
                        icon: 'creditCard',
                        order: -200,
                        dataTest: 'bindCard',
                        onClick: () => {
                            if (
                                router.activeRoute.id.indexOf('#billing-') === 0
                            ) {
                                CreditCardManager.getInstance().showCardBindingDialog();
                            } else {
                                router.nav(router.getUrl('#billing-main'), {
                                    showCardBindingDialog: true,
                                });
                            }
                        },
                    });
                }
            } else if (this._cardButtonId) {
                BoundAppHeaderActions.removeItem(this._cardButtonId);
                this._cardButtonId = undefined;

                try {
                    localStorage.setItem(
                        this.getModel().id + '|has-credit-card',
                        true,
                    );
                } catch (e) {}
            }
        },

        isAutopaymentEnabled() {
            const balanceModel = this.getModel();
            let isEnabled;

            if (balanceModel) {
                isEnabled = balanceModel.is('autopay');
            } else {
                isEnabled = false;
            }

            return isEnabled;
        },

        isPaidClient() {
            const balanceModel = this.getModel();

            if (balanceModel) {
                return (
                    balanceModel.get('balance') > 0 ||
                    balanceModel.getPostpaid()
                );
            }

            return false;
        },
    });

    module.exports = BillingService;
});
